module.exports = __webpack_public_path__ + "img/fw2.d5f5d799.png";